import { Row, Tag } from "antd";
import { Loader } from "Components/General/Loader";
import * as React from "react";

interface LabelsPreviewProps {
  fetchPreview: () => Promise<API_DataLabel[]>;
  handlePreviewError?: () => void;
}

export const LabelsPreview = ({ fetchPreview, handlePreviewError }: LabelsPreviewProps) => {
  const [labels, setLabels] = React.useState<API_DataLabel[]>([]);

  React.useEffect(() => {
    (async () => {
      try {
        const labels: API_DataLabel[] = await fetchPreview();
        setLabels(labels);
      } catch (error) {
        handlePreviewError();
      }
    })();
  }, [fetchPreview, handlePreviewError]);

  return labels.length ? (
    <Row style={{ maxWidth: 720 }}>
      {labels.map((v, idx) => (
        <Tag
          key={`${v.id}-${idx}`}
          style={{
            backgroundColor: v.bgColor,
            color: v.fgColor,
            borderColor: v.bgColor,
            marginRight: idx === labels.length - 1 ? 0 : 10,
          }}
        >
          {v.viewName}
        </Tag>
      ))}
    </Row>
  ) : (
    <Loader />
  );
};
